import gql from 'graphql-tag';

export const GRAPHQL_APPLICATIONS_QUERY = gql`
  query Applications($guarantorMmi: ID!) {
    applications(guarantorMmi: $guarantorMmi) {
      id
      status
      detailedStatus
      createDate
      updateDate
    }
  }
`;
